import {
  matchType
} from "./chunk-K54LRIUM.mjs";

// lib/utils/loading.ts
var matchLoading = (state, matcher) => {
  return matchType(state, matcher);
};

export {
  matchLoading
};
